import PageComponent from '../../common/component/page-component';


class PrintBtn extends PageComponent {

	prepare() {
		this.listeners.click = this.events.on(this.element, 'click', this.onClick.bind(this), {capture: false});
	}


	onClick(event, target) {
		event.preventDefault();
		window.print();
		target.blur();
	}


}


export default PrintBtn;
